import React, { useState } from "react";
import type { SectionComponentProps } from "../../registry.js";

interface ReservationsModalProps {
  headline?: string;
  ctaLabel?: string;
  backgroundImageUrl?: string;
}

export function ReservationsModal({ props }: SectionComponentProps) {
  const {
    headline = "Join Us for a Memorable Evening",
    ctaLabel = "Reserve Your Table",
    backgroundImageUrl,
  } = props as ReservationsModalProps;

  const [open, setOpen] = useState(false);
  const [done, setDone] = useState(false);

  return (
    <section
      className="relative py-28 px-6 flex items-center justify-center overflow-hidden"
      id="reservations"
    >
      {backgroundImageUrl ? (
        <img
          src={backgroundImageUrl}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-r from-primary/80 to-accent/80" />
      )}
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">{headline}</h2>
        <button
          onClick={() => setOpen(true)}
          className="inline-flex items-center justify-center rounded-[var(--radius)] bg-white px-10 py-4 text-base font-semibold text-foreground shadow-lg hover:bg-white/90 transition-colors"
        >
          {ctaLabel}
        </button>
      </div>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60"
          onClick={(e) => e.target === e.currentTarget && setOpen(false)}
        >
          <div className="bg-background rounded-[var(--radius)] p-8 w-full max-w-md shadow-xl">
            {done ? (
              <div className="text-center py-6">
                <div className="text-4xl mb-3">✓</div>
                <h3 className="text-xl font-semibold text-foreground mb-2">Reservation Requested</h3>
                <p className="text-muted-foreground text-sm">We'll confirm your table shortly.</p>
                <button
                  onClick={() => { setOpen(false); setDone(false); }}
                  className="mt-6 text-sm text-primary underline"
                >
                  Close
                </button>
              </div>
            ) : (
              <>
                <div className="flex justify-between items-center mb-6">
                  <h3 className="text-lg font-semibold text-foreground">Reserve a Table</h3>
                  <button onClick={() => setOpen(false)} className="text-muted-foreground hover:text-foreground text-xl">✕</button>
                </div>
                <form
                  className="space-y-4"
                  onSubmit={(e) => { e.preventDefault(); setDone(true); }}
                >
                  <input type="text" placeholder="Your name" required className="w-full rounded-[var(--radius)] border border-border bg-background px-3 py-2 text-sm" />
                  <input type="email" placeholder="Email address" required className="w-full rounded-[var(--radius)] border border-border bg-background px-3 py-2 text-sm" />
                  <div className="grid grid-cols-2 gap-3">
                    <input type="date" required className="w-full rounded-[var(--radius)] border border-border bg-background px-3 py-2 text-sm" />
                    <select required className="w-full rounded-[var(--radius)] border border-border bg-background px-3 py-2 text-sm">
                      <option value="">Time</option>
                      {["17:00","18:00","19:00","20:00","21:00"].map(t => <option key={t}>{t}</option>)}
                    </select>
                  </div>
                  <button type="submit" className="w-full rounded-[var(--radius)] bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground hover:opacity-90">
                    Request Reservation
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
